import axios from '@/http/axios/index.js'


export default {
    getVendorDocuments(payload) {
        return axios.get('rps/vendors/documents', { params: payload }).then(res => res.data)
    },
    getDocumentCatalog(payload) {
        return axios.get('rps/document/catalog', { params: payload }).then(res => res.data)
    },
    vendorDocumentStore(payload) {
        return axios.post('rps/vendor/document/store', payload).then(res => res.data)
    }
}